export default "__VITE_ASSET__CBnNbl7Q__"